let config = {};
export const setConfig = (c) => { config = c; };
export const getConfig = () => config;

